<script setup>
import { ref, reactive, computed } from "vue";
import { queryDictData } from "@/api/common";
import Vue3Tinymce from "@jsdawn/vue3-tinymce";
import {
  queryLocationById,
  insertLocation,
  updateLocation,
} from "@/api/location";
import { ElMessage } from "element-plus";

const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);

// 弹窗类型
const dialogType = ref("add");

const titleType = reactive({
  add: "新增",
  edit: "编辑",
});

// api
const requestApi = reactive({
  add: insertLocation,
  edit: updateLocation,
});

// 表单ref
const ruleRef = ref(null);

// 类型列表
const areaTypeList = ref([]);

// 弹窗loading
const loading = ref(false);

//富文本数据
const option = reactive({
  content: "hello vue3-tinymce!",
  // editor 配置项
  setting: {
    height: 400,
    toolbar:
      "undo redo | fullscreen | blocks alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontsize forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
    toolbar_mode: "sliding",
    quickbars_selection_toolbar:
      "removeformat | bold italic underline strikethrough | fontsize forecolor backcolor",
    plugins: "link image media table lists fullscreen quickbars",
    font_size_formats: "12px 14px 16px 18px",
    link_default_target: "_blank",
    link_title: false,
    nonbreaking_force_tab: true,
    // 以中文简体为例
    language: "zh-Hans",
    language_url:
      "https://unpkg.com/@jsdawn/vue3-tinymce@2.0.2/dist/tinymce/langs/zh-Hans.js",
  },
});

// 表单
const formData = reactive({
  id: null,
  name: null,
  areaType: null,
  remark: null,
  logo: null,
  ancestors: null,
  parentId: null,
});

// 表单校验
const rules = reactive({
  name: [{ required: true, message: "区域名称不可为空", trigger: "blur" }],
  areaType: [{ required: true, message: "请选择类型", trigger: "blur" }],
});

// 获取详情数据
const getLocationInfo = (id) => {
  // queryLocationById(id).then((res) => {
  //   if (JSON.stringify(res.data) !== "{}") {
  //     for (const key in formData) {
  //       formData[key] = res.data[key];
  //     }
  //   }
  // });
};

// 点击保存
const formSubmit = () => {
  ruleRef.value?.validate((valid) => {
    if (valid) {
      // requestApi[dialogType.value](formData).then((res) => {
      //   if (res.code == "2000") {
      //     ElMessage.success("操作成功");
      //     visible.value = false;
      //     emits("afterSave");
      //   }
      // });
    }
  });
};

// 弹窗打开
const handleDialogOpen = (data, type) => {
  dialogType.value = type;
  visible.value = true;
  ruleRef.value?.resetFields();
  if (type == "edit" && data.id) {
  }
};

// 函数暴露给父组件调用
defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    :title="titleType[dialogType]"
    v-model="visible"
    width="50%"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleRef"
      :model="formData"
      :rules="rules"
      label-width="80px"
      v-loading="loading"
    >
      <vue3-tinymce v-model="option.content" :setting="option.setting" />
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="formSubmit()"> 保存 </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<style lang="scss">
.tox-tinymce-aux {
  z-index: 9999 !important;
}
</style>
